export default "__VITE_ASSET__B0BdGPNU__"